export default function slider_responsiveness_breakpoints() {
	return {
		340: {
			perView: 1,
			gap: 10
		},
		540: {
			perView: 1,
			gap: 10
		},
		550: {
			perView: 1,
			gap: -10
		},
		560: {
			perView: 2,
			gap: 425
		},
		585: {
			perView: 2,
			gap: 400
		},
		620: {
			perView: 2,
			gap: 375
		},
		670: {
			perView: 2,
			gap: 350
		},
		740: {
			perView: 2,
			gap: 300
		},
		800: {
			perView: 2,
			gap: 250
		},
		870: {
			perView: 2,
			gap: 150
		},
		900: {
			perView: 2,
			gap: 125
		},
		930: {
			perView: 2,
			gap: 100
		},
		980: {
			perView: 2,
			gap: 75
		},
		1015: {
			perView: 2,
			gap: 50
		},
		1050: {
			perView: 2,
			gap: -30
		},
		1100: {
			perView: 2,
			gap: -50
		},
		1150: {
			perView: 2,
			gap: -80
		},
		1200: {
			perView: 2,
			gap: -150
		},
		1250: {
			perView: 2,
			gap: -200
		},
		1300: {
			perView: 3,
			gap: 150
		},
		1375: {
			perView: 3,
			gap: 125
		},
		1420: {
			perView: 4,
			gap: 425
		},
		1460: {
			perView: 4,
			gap: 375
		},
		1480: {
			perView: 4,
			gap: 350
		},
		1520: {
			perView: 4,
			gap: 325
		},
		1560: {
			perView: 4,
			gap: 300
		},
		1620: {
			perView: 4,
			gap: 275
		}
	};
}